import { motion } from "framer-motion";

export function Reveal({ children, className = "", delay = 0, immediate = false, ...props }) {
  const visibility = immediate
    ? { initial: { opacity: 0, y: 44 }, animate: { opacity: 1, y: 0 } }
    : { initial: { opacity: 0, y: 44 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: "-80px" } };
  return (
    <motion.div
      className={className}
      {...visibility}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
      {...props}
    >
      {children}
    </motion.div>
  );
}
